import { useEffect, useMemo } from "react";
import { CrewScheduleGL } from "src/pages/CrewSchedule/gl/CrewScheduleGL";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";

interface ISelectedCrewDaysProps {
  crewSchedGL: CrewScheduleGL;
  start: () => void;
  isAnimating: boolean;
  crew?: any;
}

export const SelectedCrewDays = (props: ISelectedCrewDaysProps): JSX.Element => {
  const { crewSchedGL, start, isAnimating, crew } = props;
  const selectedCrewDays = useSelector((state: IRootState) => state.crewSchedule.selectedCrewDays);

  const crewIsOnTimeline = useMemo(
    () => crew?.findIndex((crew: any) => crew._id === selectedCrewDays?.crewId) >= 0,
    [crew, selectedCrewDays]
  );

  useEffect(() => {
    if (!crewSchedGL) {
      return;
    }

    //only change the selected day if the selected crew is on the timeline OR there is not selected crew
    crewSchedGL.setSelectedCrewDays(selectedCrewDays?.crewId && !crewIsOnTimeline ? null : selectedCrewDays);
    if (!isAnimating) {
      start();
    }
  }, [selectedCrewDays, start, crewSchedGL, isAnimating, crewIsOnTimeline]);

  return <div></div>;
};
